import { render, staticRenderFns } from "./poNeeded.vue?vue&type=template&id=625b2206&"
import script from "./poNeeded.vue?vue&type=script&lang=js&"
export * from "./poNeeded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('625b2206')) {
      api.createRecord('625b2206', component.options)
    } else {
      api.reload('625b2206', component.options)
    }
    module.hot.accept("./poNeeded.vue?vue&type=template&id=625b2206&", function () {
      api.rerender('625b2206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/workstations/poNeeded.vue"
export default component.exports